import { atom, useAtomValue } from 'jotai';

/**
 * Atom to store the internal preview state globally
 * This is used to enable the internal admin view of a customer's cart
 */
export const internalPreviewAtom = atom<boolean>(false);

/**
 * Initialize the internal preview atom value based on URL parameters
 * Should be called once during app initialization
 */
export function initializeInternalPreview(): void {
  const params = new URLSearchParams(window.location.search);
  const internalPreview = params.get('internalIframedPreview') === 'true';

  // We need to manually set the initial value
  // This approach avoids having to export a setter function
  internalPreviewAtom.init = internalPreview;
}

/**
 * Hook to check if the internalIframedPreview query parameter is present
 * This is used to enable the internal admin view of a customer's cart
 * @returns boolean indicating if in internal preview mode
 */
export function useInternalPreview(): boolean {
  return useAtomValue(internalPreviewAtom);
}
